import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomsTransactionReferenceService extends BaseReferenceService {
  constructor() {
    super('CustomsTransactionReference');
  }
}
